import React, { useState, useEffect } from "react";
import {
  Icon,
  IconButton,
  Input,
  InputGroup,
  InputLeftElement,
  InputRightElement,
  useColorModeValue,
} from "@chakra-ui/react";
import { FaMagnifyingGlass, FaXmark } from "react-icons/fa6";
import { useHistory, useLocation } from "react-router-dom";

export function SearchBar() {
  const history = useHistory();
  const location = useLocation();
  const { search } = location;
  const params = Object.fromEntries(new URLSearchParams(search));

  const inputBg = useColorModeValue("white", "navy.800");
  const [searchQuery, setSearchQuery] = useState(params.query || "");

  // Update local state when URL changes
  useEffect(() => {
    setSearchQuery(params.query || "");
  }, [params.query, search]); // Listen to URL search changes

  const onChange = (e) => {
    setSearchQuery(e.target.value);
  };

  const onClearSearch = () => {
    setSearchQuery("");
    const newParams = new URLSearchParams(search);
    newParams.delete("query");
    history.push({ search: newParams.toString() });
  };

  const onSubmit = (e) => {
    e.preventDefault();
    const newParams = new URLSearchParams(search);
    newParams.set("query", searchQuery);
    history.push({ search: newParams.toString() });
  };

  return (
    <form onSubmit={onSubmit}>
      <InputGroup borderRadius="8px" w="200px">
        <InputLeftElement pointerEvents="none">
          <Icon as={FaMagnifyingGlass} color="gray.400" />
        </InputLeftElement>
        <Input
          bg={inputBg}
          fontSize="xs"
          onChange={onChange}
          placeholder="Search query..."
          value={searchQuery}
          variant="search"
        />
        <InputRightElement>
          {!!searchQuery && (
            <IconButton
              aria-label="Clear search"
              icon={<Icon as={FaXmark} />}
              onClick={onClearSearch}
              size="sm"
              variant="ghost"
            />
          )}
        </InputRightElement>
      </InputGroup>
    </form>
  );
}
